(() => {
  if (customElements.get('alwan-quantity')) return;

  const managedByTheme = 'quantity-input, quantity-quick-view-input, quantity-edit-cart-input, quantity-input-bulk, cart-update-quantity, quickshop-update-quantity';

  class AlwanQuantity extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.sync = this.sync.bind(this);
      this.observer = new MutationObserver(this.sync);
    }

    connectedCallback() {
      this.input = this.querySelector('.ui-quantity__input');
      if (!this.input) return;
      this.addEventListener('click', this.onClick);
      this.addEventListener('input', this.sync);
      this.addEventListener('change', this.sync);
      this.observer.observe(this.input, {
        attributes: true,
        attributeFilter: ['min', 'max', 'step', 'value', 'disabled'],
      });
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('input', this.sync);
      this.removeEventListener('change', this.sync);
      this.observer.disconnect();
    }

    onClick(event) {
      const button = event.target.closest('.ui-quantity__button');
      if (!button || !this.contains(button) || this.input.disabled || button.disabled) return;
      // Existing theme controllers own stock validation, cart updates and subtotal synchronisation.
      if (this.closest(managedByTheme) || this.input.matches('[data-bundle-quantity]')) return;
      event.preventDefault();
      if (button.name === 'plus') this.input.stepUp();
      else this.input.stepDown();
      this.input.dispatchEvent(new Event('input', {bubbles: true}));
      this.input.dispatchEvent(new Event('change', {bubbles: true}));
    }

    sync() {
      const value = this.input.valueAsNumber;
      const min = this.input.min === '' ? -Infinity : Number(this.input.min);
      const max = this.input.max === '' ? Infinity : Number(this.input.max);
      this.querySelector('[name="minus"]').disabled = this.input.disabled || value <= min;
      this.querySelector('[name="plus"]').disabled = this.input.disabled || value >= max;
    }
  }

  customElements.define('alwan-quantity', AlwanQuantity);
})();
